





































import BaseButton from '@/jbi-shared/vue-components/BaseButton.vue';
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
    BaseButton
  }
})
export default class DisableCoursePackagesModal extends Vue {
  // Funtion prop reserved for janky modal-stacking scenarios to pass pseudo-child
  // component events to parent component.
  // Refer to PublishDraftCourseModal.vue template section for more info.
  @Prop({ type: Function, default: () => {} })
  readonly confirmDelete!: () => void;
  @Prop({ type: Number, default: 0 })
  readonly activeCoursePackageCount!: number;

  @Emit('close')
  closeModal() {
    return;
  }

  // Return the function prop, but still emit event for compatibility
  @Emit('confirmDelete')
  handleConfirmDelete() {
    this.confirmDelete();
    return;
  }
}
